<template>
    <div class="bank-details-form">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Bank Name">
                            <el-select v-model="form.bank_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.banks"
                                :key="item.bank_id"
                                :label="item.name"
                                :value="item.bank_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Disbursement Bank Account Number">
                            <b-form-input
                            v-model="form.disbursement_acc_no"
                            type="text"
                            placeholder="Enter Disbursement Bank Account Number"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Account Type">
                            <el-select v-model="form.account_type" placeholder="Select">
                                <el-option
                                v-for="item in accountTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Mother's Maiden Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ name: true }"
                                :vid="'maidenName'"
                            >
                                <b-form-input
                                v-model="form.mothers_maiden_name"
                                type="text"
                                placeholder="Enter mother's maiden name"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="submit" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

    export default {
        name: 'bank-details-form',
        props: ['customer', 'tables'],
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        components: {
            ValidationObserver,
            ValidationProvider,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data() {
            const {bank_id, disbursement_acc_no, account_type, mothers_maiden_name} = this.customer.bank || {}

            return {
                form: {
                    customer_id: this.customer.customer_id,
                    bank_id: bank_id ?? null,
                    disbursement_acc_no: disbursement_acc_no ?? null,
                    account_type: account_type ?? null,
                    mothers_maiden_name: mothers_maiden_name ?? null,
                },
                accountTypeList: [
                    {
                        value: 'Saving',
                        label: 'Saving Account'
                    },
                    {
                        value: 'Loan',
                        label: 'Loan Account'
                    },
                ],
            }
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer']),
            submit(){
                this.customer.bank ? this.update(this.customer.bank.customer_bank_id) : this.create()
            },
            update(id){
                axios.put(services.customer + 'customer/'+this.customer.customer_id+'/banks/' + id, this.form, {headers: getHeader()})
                .then(res  => {
                        this.notifySuccess('<b>Bank Details: '+this.customer.name+'</b> - Successfully Updated.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            create(){
                let formData = this.generateFormData(this.form)
                axios.post(services.customer + 'customer/'+this.customer.customer_id+'/banks', formData, {headers: getHeader()})
                .then(res  => {
                    this.notifySuccess('<b>Bank Details: '+this.customer.name+'</b> - Successfully Created.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
        }
    }
</script>